export default __webpack_public_path__ + "static/media/check-black.61b3fdcb.svg";